<template>
  <v-card class="timeline-card k-card-border">
    <div class="timeline-card-head">
      <assignees :assignees="data.assignee" :show_names="true"></assignees>
      <v-spacer></v-spacer>
      <div class="timeline-card-time">
        <small>{{ data.time }}</small>
      </div>
      <v-btn class="btn btn-light" density="compact" size="small" icon><i class="fal fa-ellipse"></i></v-btn>
    </div>

    <div class="timeline-card-body">
      {{ data.message }}
    </div>
    <v-divider></v-divider>
    <div class="timeline-card-footer">
      <v-btn class="btn btn-light" density="compact" icon
        ><i class="fal fa-thumbs-up"></i
      ></v-btn>
      <v-spacer></v-spacer>
      <v-btn class="btn btn-light" size="small" icon>Reply</v-btn>
    </div>
    <div class="timeline-card-reply"></div>
  </v-card>
</template>

<script>
import Assignees from "@/components/dashboards/datafields/assignees.vue";

export default {
  components: {
    Assignees,
  },
  props: {
    data: {
      assignee: {
        type: Array,
        required: true,
        default: () => [1],
      },
      message: {
        type: String,
        required: true,
      },
      time: {
        type: String,
        default: "",
      },
    },
  },
};
</script>

<style scoped>

.timeline-card{
  margin-bottom: 10px;
}

.timeline-card .timeline-card-head{
  padding: 5px 10px!important;
  display: flex;
}

.timeline-card .timeline-card-body{
  padding: 5px 10px!important;
  font-size: 14px;
}

.timeline-card .timeline-card-footer{
  padding: 5px!important;
  display: flex;
}
</style>
